import { call } from "promised-io";
import toastr from "toastr";

export class VioletEventCalls {
    defaultOptions() {
        return {
            relinkCallOfferDelete : false,
            relinkCallId : null,
            relinkCallBootbox : null,
        }
    }
	
    constructor() {
		this.$options = $.extend({}, this.defaultOptions());
		
		this._playingAudio = null;
		this._audioCache = {};
		this.initApp();
    }
    
	//-------------------------------------------------------------------------
	
	getCallId(link) {
		const bodyId = $('body').attr('id');
        let callId = null;

        switch (bodyId) {
            case 'event':
                callId = parseInt(link.closest('div.list-group-item').attr('data-call-id'));
                break;
            
            case 'eventCalls':
                callId = parseInt(link.closest('tr').attr('id').replace('data-row-', ''));
                break;

			case 'events':
				callId = link.data('callId');
				break;
		}
		
		return callId;
	}

	displayAjaxError(r) {
		let msg = $Lang.common.unknownException;
		if (r.responseJSON && ('error' in r.responseJSON) && r.responseJSON.error) {
			msg = r.responseJSON.error;
		}
		else if (r.statusText) {
			msg += "(" + r.statusText + ")";
		}
		console.error(r);
		toastr.error(msg);
	}
	
	//-------------------------------------------------------------------------
    
    /**
	 * @param $link
	 */
	relinkCall($link) {
		const callId = this.getCallId($link);

		let	bb = bootbox.dialog({
				message: "Loading...",
				title: $Lang.events.calls.findEvent,
				size: 'large',
				buttons: {
					cancel: {
						label: $Lang.common.cancel,
						className: 'btn-danger',
						callback: function() {
							bb.modal('hide');
							$('#js-opts-common').removeData('relink');
						}
					}
				},
			});
		
		this.$options.relinkCallOfferDelete = $link.data('offerDelete');
		this.$options.relinkCallId = callId;

		$.ajax({
			type: "post",
			url: route('events.getList', {}),
			success: function (r) {
				let $body = bb.find('div.bootbox-body');
				$body.addClass("bb-events-list");
				$body.css("max-height", "" + ($(window).height() - 150) + "px")
				$body.html(r);
				window.$sbAdminDatatables.initDataTable($body.find('.js-data-table'));
			},
			error: function(r) {
				let $body = bb.find('div.bootbox-body');
				$body.html($Lang.events.calls.loadingEventsFailed);
			},
		});
		this.$options.relinkCallBootbox = bb;
    }
    
    /**
	 * @param $button
	 */
    relinkCallToEvent($button) {
		let app = this,
			eventId = $button.data('eventId'),
			offerDelete = this.$options.relinkCallOfferDelete,
			bb = this.$options.relinkCallBootbox;
		
		if (bb) {
			bb.modal('hide');
			this.$options.relinkCallBootbox = null;

			if (offerDelete) {
				bootbox.confirm({
					'title': $Lang.events.calls.deleteOriginalEvent,
					'message': $Lang.events.calls.deleteOriginalEventMessage,
					'buttons': {
						'confirm': {
							'label': $Lang.common.yes,
							'className': 'btn-danger'
						},
						'cancel': {
							'label': $Lang.common.no,
							'className': 'btn-primary'
						}
					},
					'callback': function (result) {
						app.relinkCallToEventFinish(eventId, result);
					}
				});
			} else {
				app.relinkCallToEventFinish(eventId, false);
			}
		}
		console.log(eventId, offerDelete);
	}

	/**
	 * 
	 * @param newEventId
	 * @param deleteOriginalEvent
	 */
	relinkCallToEventFinish(newEventId, deleteOriginalEvent) {
		let app = this,
			callId = this.$options.relinkCallId;
		
		$.ajax({
			type: "post",
			url: route('events.relinkCall', {}),
			data: {
				id: callId,
				newEventId: newEventId,
				deleteOriginal: deleteOriginalEvent ? 1 : 0,
			},
			success: function (r) {
				if (r && ('success' in r) && (r.success)) {
					toastr.success(r.success);
					
					if (('redirect' in r) && (r.redirect)) {
						window.location.href = r.redirect;
					}
				} else {
					toastr.error($Lang.common.unknownException);
				}
			},
			error: function(r) {
				app.displayAjaxError(r);
			},
		});
		
		console.log(newEventId, deleteOriginalEvent, callId);
	}
    
    //-------------------------------------------------------------------------

	/**
	 * 
	 * @param $button
	 */
	downloadAndPlay($button) {
		const callId = this.getCallId($button);
		this.downloadOrPlayRecord(callId, $button);
	}

	/**
	 * 
	 * @param callId
	 * @param $button
	 */
	downloadOrPlayRecord(callId, $button) {
		let app = this,
			$playerPopup = $('#audio-player-popup'),
			download = true;
		
		if ($playerPopup) {

			$playerPopup.find('.content').html("Načítám...");
			$playerPopup.show();
			
			if (callId in app._audioCache) {
				let audio = app._audioCache[callId];
				app._playingAudio = audio;
				$playerPopup.find('.content').html(audio);
				$playerPopup.show();
				audio.play();
				download = false
			}
		} 
		
		if (download) {
			$.ajax({
				type: "get",
				url: route('events.calls.play', {'call': callId}),
				timeout: 120000,
				success: function (r) {
					let audio = new Audio(r);
					audio.controls = true;

					if ($playerPopup.length > 0) {
						app._playingAudio = audio;
						$playerPopup.find('.content').html(audio);
						$playerPopup.show();

						app.setButtonState($button, true);
						
						app._audioCache[callId] = audio;
					} else {
						$button.parent().html(audio);
					}
					audio.play();

				},
				error: function (r) {
					app.displayAjaxError(r);
					app.setButtonState($button, true);
				},
			});
			this.setButtonState($button, false);
		}
	}

	/**
	 * 
	 * @param $button
	 * @param enabled
	 */
	setButtonState($button, enabled) {
		if (enabled) {
			$button.html('<i class="fas fa-play"></i>');
			$button.removeAttr('disabled');
		} else {
			$button.attr('disabled', 'disabled');
		}
	}

	/**
	 * 
	 */
	stopPlayerAndHide() {
		let $playerPopup = $('#audio-player-popup');
		
		if (this._playingAudio != null) {
			this._playingAudio.pause();
			this._playingAudio = null;
		}
		
		$playerPopup.find('.content').html("");
		$playerPopup.hide();
	}
	
	//-------------------------------------------------------------------------

	/**
	 * 
	 * @param $button
	 */
	showDownloadCallsDialog($button) {
		let app = this,
			lastCallTime = $button.data('lastCallTime'),
			now = formatDateTime(new Date(), false),
			html = "<div id='filter-calls-dialog-window'>" +
					"<div class='loading-animation'></div>" +
					"</div><div class='row mb-10'><div class='col-sm-6 form-group'>" +
						"<label for='filter-calls-time-from'>" + $Lang.common.from + "</label>" +
						"<input type='text' name='from' value='" + lastCallTime + "' class='form-control' id='filter-calls-time-from'>" +
					"</div><div class='col-sm-6 form-group'>" + 
						"<label for='filter-calls-time-to'>" + $Lang.common.to + "</label>" +
						"<input type='text' name='to' value='" + now + "' class='form-control' id='filter-calls-time-to'>" +
					"</div></div>" +
					"<div class='row'>" +
						"<div class='col-sm-4'><button role='button' class='btn btn-sm btn-outline btn-primary form-control js-filter-calls-set-time' data-time='30'>" + $Lang.events.calls.downloadLastHalfHour + "</button></div>" +
						"<div class='col-sm-4'><button role='button' class='btn btn-sm btn-outline btn-primary form-control js-filter-calls-set-time' data-time='60'>" + $Lang.events.calls.downloadLastHour + "</button></div>" +
						"<div class='col-sm-4'><button role='button' class='btn btn-sm btn-outline btn-primary form-control js-filter-calls-set-time' data-time='1440'>" + $Lang.events.calls.downloadLastDay + "</button></div>" +
					"</div></div>";
		
		let	bb = bootbox.dialog({
			message: html,
			title: $Lang.events.calls.setDateRangeTitle,
			buttons: {
				cancel: {
					label: $Lang.common.cancel,
					className: 'btn-danger',
					callback: function() {
						bb.modal('hide');
					}
				},
				ok: {
					label: $Lang.common.ok,
					className: 'btn-success',
					callback: function() {
						app.downloadCalls(bb);
						return false;
					}
				}
			},
		});
	}

	/**
	 * 
	 * @param $dialog
	 */
	downloadCalls($dialog) {
		let app = this,
			from = $dialog.find('#filter-calls-time-from').val(),
			to = $dialog.find('#filter-calls-time-to').val();
		
		$dialog.find('.loading-animation').show();
		
		$.ajax({
			type: "get",
			url: route('events.calls.download'),
			contentType: "application/json",
			data: {
				from: from,
				to: to,
			},
			timeout: 20000,
			success: function (result) {
				$dialog.modal('hide');
				app.processDownloadSuccess(result);
			},
			error: function (result) {
				if (result.responseJSON) {
					if (('errors' in result.responseJSON) && result.responseJSON.errors) {
						$dialog.find('.help-block.input-error').remove();
						inputErrors = result.responseJSON.errors;
						$customs.checkErrors();
					} else {
						toastr.error(result.responseJSON.message);
						$dialog.modal('hide');
					}
				}
				$dialog.find('.loading-animation').hide();
				console.error(result);
			}
		});
	}

	setDialogTime(subTime) {
		let time = parseDateTime($('#filter-calls-time-to').val());
		time.setTime(time.getTime() - (subTime * 60000));
		$('#filter-calls-time-from').val(formatDateTime(time, false));
	}
	
	processDownloadSuccess(result) {
		console.log(result);
		let message = $Lang.events.calls.responseDefaultMessage;
		if ('message' in result && result.message) {
			message = result.message;
		}
		bootbox.alert({
			message: message,
			title: $Lang.events.calls.setDateRangeTitle,
			callback: function() { 
				window.location.reload();
			},
		});
	}	
	
	//-------------------------------------------------------------------------

	/**
	 *
	 */
	initApp() {
		let app = this;
		
        app.initButtons();
	}
	
	/**
	 * 
	 */
	initButtons() {
        let app = this,
            $document = $(document);
        
        $document.on('click', '.js-relink-call', function (e) {
			e.preventDefault();
			$('#js-opts-common').data('relink', 'call');
			app.relinkCall($(this));
			return false;
		});
		$document.on('click', '.js-relink-button', function (e) {
			e.preventDefault();
			if ($('#js-opts-common').data('relink') === 'call') {
				app.relinkCallToEvent($(this));
				$('#js-opts-common').removeData('relink');
			}
		});
		$document.on('click', '.js-call-download-and-play', function (e) {
			e.preventDefault();
			app.downloadAndPlay($(this));
		});
		$document.on('click', '.js-close-player', function(e) {
			e.preventDefault();
			app.stopPlayerAndHide();
		});
		
		$document.on('click', '.download-missing-calls', function (e) {
			e.preventDefault();
			app.showDownloadCallsDialog($(this));
		});
		$document.on('click', '.js-filter-calls-set-time', function (e) {
			e.preventDefault();
			app.setDialogTime($(this).data('time'));
		});
	}
}
